import gql from "graphql-tag";
const GET_SCHEDULER_DATA = gql`
	query (
		$where: SchedulerJobFilterInput
		$order: [SchedulerJobSortInput!]
		$take: Int
		$skip: Int
	) {
		schedulerJobs(where: $where, order: $order, take: $take, skip: $skip) {
			totalCount
			pageInfo {
				hasNextPage
			}
			items {
				id
				name
				description
				cron
				isActive
				isExecuting
				executedOn
				lastExecutedOn
			}
		}
	}
`;
const CHANGE_SCHEDULER_JOB = gql`
	mutation ($jobData: SchedulerJobInput!) {
		changeSchedulerJob(input: $jobData) {
			isActive
		}
	}
`;
const RUN_JOB = gql`
	mutation ($name: String!) {
		runSchedulerJob(name: $name)
	}
`;
const GET_SCHEDULER_HISTORY = gql`
	query (
		$take: Int
		$skip: Int
		$order: [SchedulerJobHistorySortInput!]
		$where: SchedulerJobHistoryFilterInput
	) {
		schedulerJobHistory(
			where: $where
			take: $take
			skip: $skip
			order: $order
		) {
			totalCount
			pageInfo {
				hasNextPage
			}
			items {
				id
				date
				duration
				details
				error
			}
		}
	}
`;
export {
  CHANGE_SCHEDULER_JOB,
  GET_SCHEDULER_DATA,
  GET_SCHEDULER_HISTORY,
  RUN_JOB
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVhcnR6LmpzIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZ3JhcGhxbC9xdWFydHouanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGdxbCBmcm9tIFwiZ3JhcGhxbC10YWdcIjtcblxuZXhwb3J0IGNvbnN0IEdFVF9TQ0hFRFVMRVJfREFUQSA9IGdxbGBcblx0cXVlcnkgKFxuXHRcdCR3aGVyZTogU2NoZWR1bGVySm9iRmlsdGVySW5wdXRcblx0XHQkb3JkZXI6IFtTY2hlZHVsZXJKb2JTb3J0SW5wdXQhXVxuXHRcdCR0YWtlOiBJbnRcblx0XHQkc2tpcDogSW50XG5cdCkge1xuXHRcdHNjaGVkdWxlckpvYnMod2hlcmU6ICR3aGVyZSwgb3JkZXI6ICRvcmRlciwgdGFrZTogJHRha2UsIHNraXA6ICRza2lwKSB7XG5cdFx0XHR0b3RhbENvdW50XG5cdFx0XHRwYWdlSW5mbyB7XG5cdFx0XHRcdGhhc05leHRQYWdlXG5cdFx0XHR9XG5cdFx0XHRpdGVtcyB7XG5cdFx0XHRcdGlkXG5cdFx0XHRcdG5hbWVcblx0XHRcdFx0ZGVzY3JpcHRpb25cblx0XHRcdFx0Y3JvblxuXHRcdFx0XHRpc0FjdGl2ZVxuXHRcdFx0XHRpc0V4ZWN1dGluZ1xuXHRcdFx0XHRleGVjdXRlZE9uXG5cdFx0XHRcdGxhc3RFeGVjdXRlZE9uXG5cdFx0XHR9XG5cdFx0fVxuXHR9XG5gO1xuXG5leHBvcnQgY29uc3QgQ0hBTkdFX1NDSEVEVUxFUl9KT0IgPSBncWxgXG5cdG11dGF0aW9uICgkam9iRGF0YTogU2NoZWR1bGVySm9iSW5wdXQhKSB7XG5cdFx0Y2hhbmdlU2NoZWR1bGVySm9iKGlucHV0OiAkam9iRGF0YSkge1xuXHRcdFx0aXNBY3RpdmVcblx0XHR9XG5cdH1cbmA7XG5cbmV4cG9ydCBjb25zdCBSVU5fSk9CID0gZ3FsYFxuXHRtdXRhdGlvbiAoJG5hbWU6IFN0cmluZyEpIHtcblx0XHRydW5TY2hlZHVsZXJKb2IobmFtZTogJG5hbWUpXG5cdH1cbmA7XG5cbmV4cG9ydCBjb25zdCBHRVRfU0NIRURVTEVSX0hJU1RPUlkgPSBncWxgXG5cdHF1ZXJ5IChcblx0XHQkdGFrZTogSW50XG5cdFx0JHNraXA6IEludFxuXHRcdCRvcmRlcjogW1NjaGVkdWxlckpvYkhpc3RvcnlTb3J0SW5wdXQhXVxuXHRcdCR3aGVyZTogU2NoZWR1bGVySm9iSGlzdG9yeUZpbHRlcklucHV0XG5cdCkge1xuXHRcdHNjaGVkdWxlckpvYkhpc3RvcnkoXG5cdFx0XHR3aGVyZTogJHdoZXJlXG5cdFx0XHR0YWtlOiAkdGFrZVxuXHRcdFx0c2tpcDogJHNraXBcblx0XHRcdG9yZGVyOiAkb3JkZXJcblx0XHQpIHtcblx0XHRcdHRvdGFsQ291bnRcblx0XHRcdHBhZ2VJbmZvIHtcblx0XHRcdFx0aGFzTmV4dFBhZ2Vcblx0XHRcdH1cblx0XHRcdGl0ZW1zIHtcblx0XHRcdFx0aWRcblx0XHRcdFx0ZGF0ZVxuXHRcdFx0XHRkdXJhdGlvblxuXHRcdFx0XHRkZXRhaWxzXG5cdFx0XHRcdGVycm9yXG5cdFx0XHR9XG5cdFx0fVxuXHR9XG5gO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFFWSxNQUFDLHFCQUFxQjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQTBCdEIsTUFBQyx1QkFBdUI7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFReEIsTUFBQyxVQUFVO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFNWCxNQUFDLHdCQUF3QjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7In0=
